"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyLiteService = void 0;
const request_1 = require("../common/request");
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
class LoyaltyLiteService {
    constructor() {
        this.commonNetworkService = new nodejs_library_1.CommonNetworkService();
        this.mock = false;
    }
    setMock(mock) {
        this.mock = mock;
    }
    getSaldoPuntiVerificaAdesione(param) {
        const request = new request_1.Request(`loyalty/clienti/v2/mieiPunti/saldo`, {
            queryParams: { verificaAdesione: param ? param : false },
        });
        return this.commonNetworkService.get(request.completeUrl, request.headers);
    }
}
exports.LoyaltyLiteService = LoyaltyLiteService;
